import { booleanParser } from './booleanParser';

export function getBaseURL() {
	if (booleanParser(process.env.NEXT_PUBLIC_MAIN_SERVER)) {
		return 'https://api.kipaa.ir/interface/v1'; // primary server
	} else {
		return 'https://testapi.kipaa.ir/interface/v1'; // test server
	}
}

export function getOldBaseURL() {
	if (booleanParser(process.env.NEXT_PUBLIC_MAIN_SERVER)) {
		return 'https://api.kipaa.ir/keepaapp/v1'; // primary server
	} else {
		return 'https://testapi.kipaa.ir/keepaapp/v1'; // test server
	}
}

export function keepaApp() {
	return 'https://app.keepa.ir/';
}

export function keepaTracker(param) {
	const path = {
		// medu
		'dmedu': 'https://trc.metrix.ir/pnkqcc/',
		'7medu': 'https://trc.metrix.ir/n2q784/',
		'hmedu': 'https://trc.metrix.ir/afyvu3/',
		'cmedu': 'https://trc.metrix.ir/q2bxxo/',
		'damedu': 'https://trc.metrix.ir/w82vz8/',
		'wmedu': 'https://trc.metrix.ir/yp4zj9/',
		// entekhabino
		'ptb': 'https://trc.metrix.ir/vgqcl0/',
		'qtb': 'https://trc.metrix.ir/t2g4pw/',
		'rtb': 'https://trc.metrix.ir/5h8o56/',
		'stb': 'https://trc.metrix.ir/ykceys/',
		'ttb': 'https://trc.metrix.ir/lobg6f/',
		'utb': 'https://trc.metrix.ir/ulx0ze/',
		'vtb': 'https://trc.metrix.ir/cqtzsy/',
		'wtb': 'https://trc.metrix.ir/hrioyu/',
		'xtb': 'https://trc.metrix.ir/xjv2vw/',
		'ytb': 'https://trc.metrix.ir/kmjmoy/',
		// entekhab or old snowa
		'atb': 'https://trc.metrix.ir/zjfllb/',
		'btb': 'https://trc.metrix.ir/pght9v/',
		'ctb': 'https://trc.metrix.ir/987zv4/',
		'dtb': 'https://trc.metrix.ir/k78jkq/',
		'etb': 'https://trc.metrix.ir/qfnsse/',
		'ftb': 'https://trc.metrix.ir/4usbcn/',
		'gtb': 'https://trc.metrix.ir/w6f8xe/',
		'htb': 'https://trc.metrix.ir/7judep/',
		'itb': 'https://trc.metrix.ir/82fvcb/',
		'jtb': 'https://trc.metrix.ir/m0sr3w/',
	};

	return path[param] || 'https://trc.metrix.ir/qjot9y/';
}
